import { ProgressSpinner, DatePicker, Alert } from 'callahan-react'
import Moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'

import { fetchQuantifiedSites } from '../../actions/quantified-sites-actions'
import BackButton from '../../components/BackButton'
import { earliestDateLimit } from '../../constants/value-constants'

import '../default.css'
import './quantified-sites.css'
import 'react-table/react-table.css'

const propTypes = {
  isRequestingQuantifiedSites: PropTypes.bool,
  requestQuantifiedSitesError: PropTypes.bool,
  quantifiedSitesData: PropTypes.array,
  pages: PropTypes.number
}

export class QuantifiedSites extends Component {
  constructor() {
    super()
    this.state = {
      fromDate: Moment().subtract(30, 'day'),
      toDate: Moment(),
      showDateRangeError: false
    }
  }

  getSortQueryString = state => {
    let sortMethod = ''

    if (state.sorted[0]) {
      if (state.sorted[0].desc) {
        sortMethod = '-'
      }
      if (state.sorted[0].id === 'createdDatetime') {
        sortMethod += 'created'
      } else if (state.sorted[0].id === 'globalUniques') {
        sortMethod += 'uniques'
      } else {
        sortMethod += state.sorted[0].id
      }
    } else {
      sortMethod = '-created'
    }
    return sortMethod
  }

  dateChanged = (fromDate, toDate) => {
    if (toDate.isBefore(fromDate.clone().add(31, 'days'))) {
      this.setState({ fromDate, toDate, showDateRangeError: false })
      let query = new URLSearchParams()
      query.append('startDate', fromDate.valueOf())
      query.append('endDate', toDate.valueOf())
      this.props.dispatch(fetchQuantifiedSites(query.toString()))
    } else {
      this.setState({ showDateRangeError: true })
    }
  }

  renderGlobalUniquesCell = props => {
    const { value } = props
    const uniquesValue = value >= 0 ? value.toLocaleString() : '-'
    return <React.Fragment>{uniquesValue}</React.Fragment>
  }

  render() {
    const { fromDate, toDate, showDateRangeError } = this.state
    const columns = [
      {
        Header: 'Site',
        accessor: 'name',
        Cell: props => {
          const { name, pcode } = props.row
          return <a href={`/measure/profile/site/p-${pcode}/${name}`}>{props.value}</a>
        }
      },
      {
        Header: 'p-code',
        accessor: 'pcode',
        minWidth: 100,
        Cell: props => {
          const { pcode } = props.row
          return <a href={`/measure/profile/network/p-${pcode}`}>{props.value}</a>
        }
      },
      {
        Header: 'Global Uniques',
        accessor: 'globalUniques',
        Cell: this.renderGlobalUniquesCell,
        minWidth: 100
      },
      {
        Header: 'Created Date',
        accessor: 'createdDatetime',
        minWidth: 120
      }
    ]
    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton />
          <h1 className="page-title">Quantified Sites Report</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        <DatePicker
          className="quantified-sites-date-picker"
          datePickerType="input"
          fromDate={fromDate}
          toDate={toDate}
          acceptableFromDate={Moment(earliestDateLimit)}
          acceptableToDate={Moment()}
          onChange={this.dateChanged}
        />
        {this.props.isRequestingQuantifiedSites && (
          <ProgressSpinner size="small" className="quantified-sites-loading-table" />
        )}
        {showDateRangeError && (
          <Alert
            title={'Date range must not exceed 30 days'}
            color={'error'}
            className="quantified-sites-error"
          />
        )}
        {!showDateRangeError && (
          <ReactTable
            className="quantified-sites-data-table"
            data={this.props.quantifiedSitesData}
            pages={this.props.pages}
            columns={columns}
            manual={true}
            onFetchData={state => {
              let query = new URLSearchParams()
              query.append('offset', state.page * state.pageSize)
              query.append('pageSize', state.pageSize)
              query.append('sort', this.getSortQueryString(state))
              query.append('startDate', fromDate.valueOf())
              query.append('endDate', toDate.valueOf())
              this.props.dispatch(fetchQuantifiedSites(query.toString()))
            }}
          />
        )}
      </div>
    )
  }
}
QuantifiedSites.propTypes = propTypes

function mapStateToProps(state) {
  const { quantifiedSites } = state
  return {
    isRequestingQuantifiedSites: quantifiedSites.isRequestingQuantifiedSites,
    requestQuantifiedSitesError: quantifiedSites.requestQuantifiedSitesError,
    quantifiedSitesData: quantifiedSites.data,
    pages: quantifiedSites.pages
  }
}

export default connect(mapStateToProps)(QuantifiedSites)



// WEBPACK FOOTER //
// ./src/pages/QuantifiedSites/QuantifiedSites.js